import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const CREATE_SIMULATE_EHR_REQUEST = 'CREATE_SIMULATE_EHR_REQUEST';
export const CREATE_SIMULATE_EHR_SUCCESS = 'CREATE_SIMULATE_EHR_SUCCESS';
export const CREATE_SIMULATE_EHR_ERROR = 'CREATE_SIMULATE_EHR_ERROR';
export const CREATE_SIMULATE_EHR_RESET = 'CREATE_SIMULATE_EHR_RESET';

export const createSimulateEhrApi = (data) => {
	return async (dispatch) => {
		dispatch({ type: CREATE_SIMULATE_EHR_REQUEST });
		try {
			const response = await axios.post(
				`${config.api.base_url}/simulate-ehr/create`,
				data,
				{
					headers: {
						'Content-type': 'application/json; charset=UTF-8',
						Authorization: 'Bearer ' + getUserToken(),
					},
				},
			);
			dispatch({
				type: CREATE_SIMULATE_EHR_SUCCESS,
				payload: response.data,
			});
		} catch (error) {
			dispatch({
				type: CREATE_SIMULATE_EHR_ERROR,
				payload: error.response?.data?.message || 'Something went wrong',
			});
		}
	};
};

export const createSimulateEhrReset = () => {
	return {
		type: CREATE_SIMULATE_EHR_RESET,
	};
}; 